import { gql } from "@apollo/client";

/* Login the user with email and password */
export const LOGIN_MUTATION = gql`
  mutation ($email: String!, $password: String!, $authProfileId: ID!) {
    userLogin(
      data: {
        email: $email
        password: $password
        authProfileId: $authProfileId
      }
    ) {
      auth {
        refreshToken
        idToken
      }
    }
  }
`;

/* Sign up the user with email and password */
export const SIGNUP_MUTATION = gql`
  mutation ($email: String!, $password: String!, $authProfileId: ID!) {
    userSignUpWithPassword(
      user: { email: $email }
      password: $password
      authProfileId: $authProfileId
    ) {
      id
      email
      createdAt
    }
  }
`;

/* Send user password reset email */
export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ($email: String!) {
    userForgotPassword(email: $email) {
      success
    }
  }
`;

/**
 * Query the current users details.
 */
export const CURRENT_USER_QUERY = gql`
  query {
    user {
      createdAt
      updatedAt
      deletedAt
      email
      firstName
      id
      lastName
      origin
      status
      _description
      userTimezone
      avatar {
        downloadUrl
        shareUrl
      }
      roles {
        items {
          name
        }
      }
    }
  }
`;

/**
 * Update current user's time zone (User.userTimezone).
 * Spec: specs/time-zone-support (WEB-1).
 */
export const UPDATE_USER_TIMEZONE_MUTATION = gql`
  mutation UpdateUserTimezone($data: UpdateUserTimezoneInput!) {
    updateUserTimezone(data: $data) {
      success
      message
      user {
        id
        userTimezone
        updatedAt
      }
      errors
    }
  }
`;
